module.exports = __webpack_public_path__ + "media/images/client-logos/client-logo_lbg-255fa83ed3a95b5ff9926e8adfbb2293.png";